module.exports = __webpack_public_path__ + "img/section4Logo1.44fc4e13.webp";